/**
 * BackToLeadPerformance — standardized back control surfaced on report pages
 * (Marketing Attribution, Dispositions, Lead Integrity, etc.) that are folded
 * under the Lead Performance hub. Provides a single, consistent way to return
 * to /growth-channels across the site.
 *
 * Visual standard: ghost-button styling with leading ArrowLeft icon, sized to
 * sit above the page H1. Use this component anywhere a folded surface needs a
 * back link to its parent hub.
 */
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function BackToLeadPerformance() {
  return (
    <Link
      to="/growth-channels"
      data-back-link="lead-performance"
      className="inline-flex items-center gap-1.5 -ml-2 px-2 py-1 rounded-md text-xs font-medium text-muted-foreground hover:text-foreground hover:bg-muted/60 transition-colors"
    >
      <ArrowLeft className="h-3.5 w-3.5" />
      Back to Lead Performance
    </Link>
  );
}
